import React , {Component} from 'react';
import firebase from 'firebase';
import {Bar,Line,Pie} from 'react-chartjs-2';


const database=firebase.database();

class ChartLine extends Component{

	
	
	constructor(props){
		
		super(props);
		
		this.state={
			meses:['Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'],
			num_meses:[],
			cargar:false,
			chartData:{
				labels:[],
				datasets:[
					{
						label:'Viajes',
						data:[0,0,0],
						cargar:false,
						backgroundColor:[
							
							
							  'rgba(138,221,45,0.6)',
							  'rgba(255, 159, 64, 0.6)',
							  'rgba(153, 102, 255, 0.6)',							 
							  'rgba(255, 99, 132, 0.6)',						
							  'rgba(54, 162, 235, 0.6)',
							  
							  
							  
							  'rgba(75, 192, 192, 0.6)',
							  'rgba(255, 99, 132, 0.6)',							  
							  'rgba(255, 206, 86, 0.6)'							  
							  
							  
						]
						
						
					}
				]
				
			}
			
		}
		
		this.renderChart=this.renderChart.bind(this);
	
			let hoy=new Date();
				
				let mm=hoy.getMonth();
				let yyyy=hoy.getFullYear();
				
				
				let cont=0;
				
			
				for(let i=(mm-2);i<=mm;i++){
			
					let mes;
					
					if(i===-2){
						
						mes=this.state.meses[10];
						this.state.num_meses[cont]=10;
					}
					else if(i===-1){
						
						mes=this.state.meses[11];
						this.state.num_meses[cont]=11;
					}
					else{
						
						mes=this.state.meses[i];
						this.state.num_meses[cont]=i;
						
					}
					
					
					this.state.chartData.labels[cont]=mes;
					
					//this.state.chartData.datasets[0].data[cont]=(100*Math.random());
					cont++;
			
				}
				
				this.viajesRef=database.ref().child('Viaje');

	
	}
	
	
	
	componentDidMount(){		
		
		this.viajesRef.on('value',this.gotData,this.errData);
		
	}
	
	
	componentWillMount(){
		
		
		this.viajesRef.on('value',this.gotData,this.errData);
		
		
	}
	
	
	gotData=(data)=>{
		
		
		let hoy=new Date();
		let mm=hoy.getMonth();
		let anio=hoy.getFullYear();
		let yyyy=hoy.getFullYear();
		this.state.chartData.datasets[0].data[2]=0;
		this.state.chartData.datasets[0].data[1]=0;
		this.state.chartData.datasets[0].data[0]=0;
		
		mm='0'+(mm+1);
		
		
		
		
		
		let newViaje=[];
		
		
		
		if(data.val()!==null){
			
			let dataviajes=data.val();
			
			let keys=Object.keys(dataviajes);
			
			for(let i=0;i<keys.length;i++){
				
				let k=keys[i];
				
				//Mes 5,7
				//Año 0,4
				let mes;
				let enero;
				let febrero;
				let marzo;
				
				
			try{
				
				mes=((this.state.num_meses[2]+1)<9?'0':'')+(this.state.num_meses[2]+1);				
				if(dataviajes[k].fechaBajada!==undefined && dataviajes[k].fechaBajada.substring(5,7) === mes  && dataviajes[k].fechaBajada.substring(0,4)===''+anio){
					
					
					this.state.chartData.datasets[0].data[2]+=1;
					
				}
				
				mes=((this.state.num_meses[1]+1)<9?'0':'')+(this.state.num_meses[1]+1);
			
				if(dataviajes[k].fechaBajada!==undefined && dataviajes[k].fechaBajada.substring(5,7)===mes && dataviajes[k].fechaBajada.substring(0,4)===''+anio){
					
					
					this.state.chartData.datasets[0].data[1]+=1
					
				}
				
				mes=((this.state.num_meses[0]+1)<9?'0':'')+(this.state.num_meses[0]+1);
				if(dataviajes[k].fechaBajada!==undefined && dataviajes[k].fechaBajada.substring(5,7)===mes && dataviajes[k].fechaBajada.substring(0,4)===''+anio){
					
					
					this.state.chartData.datasets[0].data[0]+=1
					
				}
			}
			catch(error){
				console.log(error)
			}
				
			}
			this.setState({
					chartData:this.state.chartData,
					cargar:true
			})
			
			
		}
		
		
		
	}
	errData=(err)=>{
		
		
		
	}
	
	
	renderChart(){
		
		return(
		
					<Line
						data={this.state.chartData}
						width={65}
						height={35}
						options={{}}
					/>
		
		
		);
		
	}
	
	
	render(){
		
		return(
		
				<div className="chart_line">
					
					
					{this.state.cargar?this.renderChart():''}
					
				
				</div>

	
		)
		
		
	}
	
	
} 

export default ChartLine;


// WEBPACK FOOTER //
// ./src/Components/Charts/ChartLine.js